<script setup lang="ts">
import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import { faEllipsisVertical, faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

defineOptions({
  name: 'UserDetailActions',
})

const emit = defineEmits<{
  'click:delete': []
}>()

const isOpen = ref(false)
const containerRef = ref<HTMLElement | null>(null)
const floatingRef = ref<HTMLElement | null>(null)

const { floatingStyles } = useFloating(containerRef, floatingRef, {
  placement: 'bottom-end',
  strategy: 'fixed',
  whileElementsMounted: autoUpdate,
  middleware: [
    offset(4),
    flip(),
    shift({ padding: 8 }),
  ],
})

const toggle = (): void => {
  isOpen.value = !isOpen.value
}

const handleDelete = (): void => {
  isOpen.value = false
  emit('click:delete')
}

onClickOutside(containerRef, () => {
  isOpen.value = false
})
</script>

<template>
  <div
    ref="containerRef"
    class="user-detail-actions"
  >
    <BtnIcon
      :icon="faEllipsisVertical"
      view="transparent"
      title="Actions"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="user-detail-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Delete user"
          color="red"
          :prepend-icon="faTrashCan"
          @click="handleDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./UserDetailActions.scss" />
